import { render, staticRenderFns } from "./PriceEditTable.vue?vue&type=template&id=08207cea&scoped=true&"
import script from "./PriceEditTable.vue?vue&type=script&lang=js&"
export * from "./PriceEditTable.vue?vue&type=script&lang=js&"
import style0 from "./PriceEditTable.vue?vue&type=style&index=0&id=08207cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08207cea",
  null
  
)

/* custom blocks */
import block0 from "./PriceEditTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VEditDialog,VTextField,VTooltip})
